import { Analytics, useAnalytics } from "@iyk/vf-observability/react"
import React from "react"

export const useExclusiveSheet = (exclusiveId: string) => {
  const [open, setOpen] = React.useState(false)
  const analytics = useAnalytics()

  const handleSetOpen = (open: boolean) => {
    setOpen(open)
    if (open) {
      analytics.track(Analytics.Event.ExclusiveViewed({ exclusiveId }))
    }
  }

  return [open, handleSetOpen] as const
}
